import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";

export default class LSFaq extends Plugin {
    init() {
        // on récupère l'objet editor de l'éditeur
        const editor = this.editor;
        // sur la propriété ui l'éditeur on invoque la compenentFactory pour créer un bouton
        editor.ui.componentFactory.add("ls_faq", (locale) => {
            // 'ls_faq' est le nom du bouton à déclarer dans la barre d'outils de l'éditeur
            // on crée un bouton
            const button = new ButtonView(locale);

            // on défini le label du bouton
            button.set({
                // icon: Icon,
                label: "FAQ",
                withText: true,
                tooltip: true,
            });

            // on écoute l'événement de click sur le bouton et on invoque la fonction _fetchBloc()
            this.listenTo(button, "execute", () => {
                const event = new CustomEvent("ckAddFaq", {
                    detail: {
                        editor: editor,
                        type: "faq",
                    },
                });
                document.dispatchEvent(event);
            });
            return button;
        });
    }
}
